export const translations = {
  tableOfContents: {
    en: 'Table of contents',
    ru: 'Оглавление'
  },
  github: {
    en: 'Source Code',
    ru: 'Source Code'
  },
  disclaimer: {
    en: 'Legal disclaimer',
    ru: 'Правовая оговорка'
  },
  lastUpdate: {
    en: 'Page last updated',
    ru: 'Последнее обновление страницы'
  }
}
export const disclaimer = {
  en: [
    'The sole purpose of this White Paper is to outline the objectives and proposed architecture of YourJustice to those, who may be interested.',
    'This White Paper and its contents do not, and are not intended to, constitute, or form any part of, an offer for sale, prospectus or invitation to subscribe for or purchase Tokens. Nothing in White Paper can be considered as “investment advice” for any purpose. If and when YourJustice proceeds with offering for sale and subscription its Tokens, it will do so through definitive sale and subscription documents.',
    'Nothing in this White Paper should be read as a promise of how YourJustice business will develop or of the utility or value of its Tokens. This White Paper outlines current plans, which could change for any number of reasons at the discretion of the board of directors of YourJustice. The ongoing development and maintenance of the YourJustice Platform may be abandoned and/or materially modified for a number of reasons, including, but not limited to, lack of interest from the public, lack of funding, lack of commercial success or prospects, or departure of key personnel.',
    'The industry in which YourJustice operates is new and the regulatory status of organisations such as YourJustice, blockchain technology and Tokens is unsettled in many jurisdictions. It is therefore difficult to predict how or whether governmental authorities may regulate YourJustice, the YourJustice Platform and the Tokens. YourJustice may therefore cease the development and any of the activities of the YourJustice Platform in the event that governmental actions make it unlawful or commercially undesirable to continue to do so.',
    'Statements contained in the White Paper may constitute “forward-looking statements”. Forward-looking statements are generally identifiable by the use of the words “may”, “will”, “should”, “plan”, “expect”, “anticipate”, “estimate”, “believe”, “intend”, “project”, “goal” or “target” or the negative of these words or other variations on these words or comparable terminology. Forward-looking statements are based on current expectations and involve a number of known and unknown risks, uncertainties and other factors that could cause the actual performance of YourJustice to be materially different from any future performance expressed or implied by such forward-looking statements.',
    'You should not place undue reliance on forward-looking statements and no undertaking is given to publicly update or revise any forward-looking statements that may be made herein, whether as a result of new information, future events or otherwise.'
  ],
  ru: [
    'Единственная цель этой Белой книги — изложить цели и предлагаемую архитектуру YourJustice для тех, кто может быть заинтересован.',
    'This White Paper and its contents do not, and are not intended to, constitute, or form any part of, an offer for sale, prospectus or invitation to subscribe for or purchase Tokens. Nothing in White Paper can be considered as “investment advice” for any purpose. If and when YourJustice proceeds with offering for sale and subscription its Tokens, it will do so through definitive sale and subscription documents.',
    'Nothing in this White Paper should be read as a promise of how YourJustice business will develop or of the utility or value of its Tokens. This White Paper outlines current plans, which could change for any number of reasons at the discretion of the board of directors of YourJustice. The ongoing development and maintenance of the YourJustice Platform may be abandoned and/or materially modified for a number of reasons, including, but not limited to, lack of interest from the public, lack of funding, lack of commercial success or prospects, or departure of key personnel.',
    'The industry in which YourJustice operates is new and the regulatory status of organisations such as YourJustice, blockchain technology and Tokens is unsettled in many jurisdictions. It is therefore difficult to predict how or whether governmental authorities may regulate YourJustice, the YourJustice Platform and the Tokens. YourJustice may therefore cease the development and any of the activities of the YourJustice Platform in the event that governmental actions make it unlawful or commercially undesirable to continue to do so.',
    'Statements contained in the White Paper may constitute “forward-looking statements”. Forward-looking statements are generally identifiable by the use of the words “may”, “will”, “should”, “plan”, “expect”, “anticipate”, “estimate”, “believe”, “intend”, “project”, “goal” or “target” or the negative of these words or other variations on these words or comparable terminology. Forward-looking statements are based on current expectations and involve a number of known and unknown risks, uncertainties and other factors that could cause the actual performance of YourJustice to be materially different from any future performance expressed or implied by such forward-looking statements.',
    'You should not place undue reliance on forward-looking statements and no undertaking is given to publicly update or revise any forward-looking statements that may be made herein, whether as a result of new information, future events or otherwise.'
  ]
}
export const links = [
  {
    text: {
      en: 'An Abstract ',
      ru: 'Аннотация'
    },
    link: 'an-abstract'
  },
  {
    text: {
      en: 'Chapter 1: Problem and Conceptual Solution ',
      ru: 'Глава 1. Проблема и концептуальное решение'
    },
    link: 'chapter-one',
    inners: [
      {
        text: {
          en: '3 levels of failures',
          ru: 'Три уровня сбоев'
        },
        link: 'chapter-one#three-levels-of-failures'
      },
      {
        text: {
          en: 'The problem as it is',
          ru: 'Суть проблемы'
        },
        link: 'chapter-one#the-problem-as-it-is'
      },
      {
        text: {
          en: 'Why did it happen?',
          ru: 'Почему так произошло?'
        },
        link: 'chapter-one#why-did-it-happen'
      },
      {
        text: {
          en: 'Demand for decentralization of relations',
          ru: 'Спрос на децентрализацию отношений'
        },
        link: 'chapter-one#demand-for-decentralization-of-relations'
      },
      {
        text: {
          en: 'The YourJustice Solution',
          ru: 'Решение YourJustice'
        },
        link: 'chapter-one#the-yourjustice-solution'
      },
      {
        text: {
          en: 'A quick overview of the platform',
          ru: 'Краткий обзор платформы'
        },
        link: 'chapter-one#a-quick-overview-of-the-platform'
      },
      {
        text: {
          en: 'Agents of changes (changemakers), that is, you!',
          ru: 'Агенты изменений. То есть вы!'
        },
        link: 'chapter-one#agents-of-changes-that-is-yo'
      },
      {
        text: {
          en: 'What we expect and what we strive for?',
          ru: 'Что мы ожидаем и к чему стремимся?'
        },
        link: 'chapter-one#what-we-expect-and-what-we-strive-for'
      }
    ]
  },
  {
    text: {
      en: 'Chapter 2 - How the Platform Works',
      ru: 'Глава 2. Как устроена платформа'
    },
    link: 'chapter-two',
    inners: [
      {
        text: {
          en: 'Tiles - a framework for describing role systems',
          ru: 'Тайлы — фреймворк для описания ролевых систем'
        },
        link: 'chapter-two#tiles'
      },
      {
        text: {
          en: 'Sample Tiles: Humanity',
          ru: 'Примеры тайлов: Humanity'
        },
        link: 'chapter-two#humanity'
      },
      {
        text: {
          en: 'Sample Tiles: The Tribe of Silence Lovers',
          ru: 'Примеры тайлов: Племя любителей тишины'
        },
        link: 'chapter-two#silence-lovers'
      },
      {
        text: {
          en: 'Sample Tiles: Contract',
          ru: 'Примеры тайлов: Контракт'
        },
        link: 'chapter-two#sample-tiles'
      },
      ,
      {
        text: {
          en: 'Tile samples: YJML standardized smart law',
          ru: 'Примеры тайлов: YJML-смарт-закон'
        },
        link: 'chapter-two#standardized-smart-law'
      },
      {
        text: {
          en: 'Scores',
          ru: 'Рейтинги'
        },
        link: 'chapter-two#scores'
      },
      {
        text: {
          en: 'Courts',
          ru: 'Суды'
        },
        link: 'chapter-two#courts'
      },
      {
        text: {
          en: 'Human Entity',
          ru: 'Human Entity'
        },
        link: 'chapter-two#human-entity'
      },
      ,
      {
        text: {
          en: 'Nicknames',
          ru: 'Псевдонимы'
        },
        link: 'chapter-two#nicknames'
      },
      {
        text: {
          en: 'Tribal Economics. Cross-Chain Finance',
          ru: 'Экономика племен. Cross-Chain'
        },
        link: 'chapter-two#cross-chain-finance'
      }
    ]
  }
]
export const inProgress = [
  {
    en: 'Chapter 3 - User Stories and Benefints',
    ru: 'Chapter 3 - User Stories and Benefints'
  },
  {
    en: 'Chapter 4 - Contact With Legacy Legal Systems',
    ru: 'Chapter 4 - Contact With Legacy Legal Systems'
  },
  {
    en: 'Chapter 5 - Architecture and Tech Solution',
    ru: 'Chapter 5 - Architecture and Tech Solution'
  }
]
